import { DxMp_Fwd_Lnk } from '../models/domain/dxmp_fwd_lnk.';
import { CommonEnums } from '../common.enums';

export class DxMp_Fwd_LnksUtil {
    private static instance: DxMp_Fwd_LnksUtil;

    static getInstance() {
        if (!DxMp_Fwd_LnksUtil.instance) {
            DxMp_Fwd_LnksUtil.instance = new DxMp_Fwd_LnksUtil();
        }

        return DxMp_Fwd_LnksUtil.instance;
    }

    /**
    * DxMp_Fwd_LnksUtil is a singleton class, so use DxMp_Fwd_LnksUtil.getInstance() method instead of creating new DxMp_Fwd_LnksUtil().
    */
    private constructor() {

    }

    /**
     * `getPrimaryKey()` method is used to get the composite key of dxMp_Fwd_Lnk.
     */
    getPrimaryKey(dxMp_Fwd_Lnk: DxMp_Fwd_Lnk): string {
        return dxMp_Fwd_Lnk.dxMp_Id + "." + dxMp_Fwd_Lnk.obj_Id + "." + dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id
            + "." + dxMp_Fwd_Lnk.grp_Id + "." + dxMp_Fwd_Lnk.fwd_Lnk_Grp_Id;
    }

    /**
     * `getInLinksCount()` method is used to get the total in links of the transform.
     */
    getInLinksCount(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): number {
        let inLinkCount: number = 0;

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id == transform_Id) {
                inLinkCount++;
            }
        }

        return inLinkCount;
    }

    /**
     * `getOutLinksCount()` method is used to get the total out links of the transform.
     */
    getOutLinksCount(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): number {
        let outLinkCount: number = 0;

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].obj_Id == transform_Id) {
                outLinkCount++;
            }
        }

        return outLinkCount;
    }

    /**
     * `getInOutLinksCount()` method is used to get the total in and out links of the transform.
     * @return array of numbers, 
     * in links count will be 0 position
     * and out links count will be 1st position.
     */
    getInOutLinksCount(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): Array<number> {
        let inLinkCount: number = 0;
        let outLinkCount: number = 0;

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].obj_Id == transform_Id)
                outLinkCount++;

            if (dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id == transform_Id)
                inLinkCount++;
        }

        return [inLinkCount, outLinkCount];
    }

    /**
     * `hasOutLink()` method is used to determine whether transform has out link or not.
     */
    hasOutLink(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): boolean {
        return this.getOutLinksCount(transform_Id, dxMp_Fwd_Lnks) > 0;
    }

    /**
     * `hasInLink()` method is used to determine whether transform has in link or not.
     */
    hasInLink(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): boolean {
        return this.getInLinksCount(transform_Id, dxMp_Fwd_Lnks) > 0;
    }

    getPreceedingTransform_Ids(transform_Id: number, fwd_Lnk_Grp_Id: number,
        dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): Array<number> {
        let preceedingTransform_Ids: Array<number> = new Array<number>();

        let immediatePreceedingTransform_Id: number = -1;
        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i];

            if (dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id == transform_Id) {
                if (fwd_Lnk_Grp_Id == -1) {
                    immediatePreceedingTransform_Id = dxMp_Fwd_Lnk.obj_Id;
                } else if (dxMp_Fwd_Lnk.fwd_Lnk_Grp_Id == fwd_Lnk_Grp_Id) {
                    immediatePreceedingTransform_Id = dxMp_Fwd_Lnk.obj_Id;
                }
            }
        }
        if (immediatePreceedingTransform_Id == -1) {
            return preceedingTransform_Ids;
        }

        this._getPreceedingTransform_IdsRecursion(immediatePreceedingTransform_Id, dxMp_Fwd_Lnks, preceedingTransform_Ids);
        return preceedingTransform_Ids;
    }

    private _getPreceedingTransform_IdsRecursion(transform_Id: number, dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>,
        preceedingTransform_Ids: Array<number>): void {
        preceedingTransform_Ids.push(transform_Id);

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id != transform_Id) continue;

            this._getPreceedingTransform_IdsRecursion(dxMp_Fwd_Lnks[i].obj_Id, dxMp_Fwd_Lnks, preceedingTransform_Ids);
        }
    }




    getDxMp_Fwd_LnkBasedOnFwd_Lnk_Grp_Id(dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, fwd_Lnk_Grp_Id: number, fwd_Lnk_Obj_Id: number) {

        if (fwd_Lnk_Obj_Id) {
            for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
                if (dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id == fwd_Lnk_Obj_Id &&
                    dxMp_Fwd_Lnks[i].fwd_Lnk_Grp_Id == fwd_Lnk_Grp_Id)
                    return dxMp_Fwd_Lnks[i];
            }
        } else {
            for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
                if (dxMp_Fwd_Lnks[i].fwd_Lnk_Grp_Id == fwd_Lnk_Grp_Id)
                    return dxMp_Fwd_Lnks[i];
            }
        }

        return null;
    }

    copy(dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): Array<DxMp_Fwd_Lnk> {
        let dxMp_Fwd_LnksTmp: Array<DxMp_Fwd_Lnk> = new Array<DxMp_Fwd_Lnk>();

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i] as DxMp_Fwd_Lnk;
            dxMp_Fwd_LnksTmp.push(dxMp_Fwd_Lnk.copy());
        }

        return dxMp_Fwd_LnksTmp;
    }

    copyFrom(dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, dxMp_Fwd_LnksTmp: Array<DxMp_Fwd_Lnk>): void {
        let dxMp_Fwd_LnksMap: Map<string, DxMp_Fwd_Lnk> = new Map();

        let dxMp_Fwd_LnkLength: number = dxMp_Fwd_Lnks.length;
        for (let i: number = 0; i < dxMp_Fwd_LnkLength; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i] as DxMp_Fwd_Lnk;
            dxMp_Fwd_LnksMap.set(this.getPrimaryKey(dxMp_Fwd_Lnk), dxMp_Fwd_Lnk);
        }
        dxMp_Fwd_Lnks.splice(0, dxMp_Fwd_Lnks.length);

        let dxMp_Fwd_LnksTmpLength: number = dxMp_Fwd_LnksTmp.length;
        for (let i: number = 0; i < dxMp_Fwd_LnksTmpLength; i++) {
            let dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk = dxMp_Fwd_LnksTmp[i] as DxMp_Fwd_Lnk;
            let dxMp_Fwd_Lnk = dxMp_Fwd_LnksMap.get(this.getPrimaryKey(dxMp_Fwd_LnkTmp));
            if (dxMp_Fwd_Lnk) {
                dxMp_Fwd_Lnk.copyFrom(dxMp_Fwd_LnkTmp);
            } else {
                dxMp_Fwd_Lnk = DxMp_Fwd_Lnk.parse(dxMp_Fwd_LnkTmp)
            }
            dxMp_Fwd_Lnks.push(dxMp_Fwd_Lnk);
        }
    }

    compare(dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>, dxMp_Fwd_LnksTmp: Array<DxMp_Fwd_Lnk>): string {
        if (dxMp_Fwd_Lnks.length != dxMp_Fwd_LnksTmp.length) {
            return "dxMp_Fwd_Lnks length mismatch.";
        }

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i] as DxMp_Fwd_Lnk;
            let dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk = dxMp_Fwd_LnksTmp[i] as DxMp_Fwd_Lnk;

            let diffString: string = dxMp_Fwd_Lnk.compare(dxMp_Fwd_LnkTmp);
            if (diffString != "") {
                return diffString;
            }
        }

        return "";
    }

    toString(dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>): string {
        let str: string = "";
        str += 'DxMp_Fwd_Lnk length: ' + dxMp_Fwd_Lnks.length + ' ';

        for (let i: number = 0; i < dxMp_Fwd_Lnks.length; i++) {
            let dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk = dxMp_Fwd_Lnks[i] as DxMp_Fwd_Lnk;
            str += dxMp_Fwd_LnkTmp.toString();
        }
        return str;
    }
}

